module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-1be3ba18063e176defb60660047ed383.png";